<template>
  <div class="content-scoll">
    <div class="teacher-area">
      <div class="teacher">
        <div class="text-center">
          <button
            @click="clientCurrent = null"
            class="mt-4 mb-4 btn btn-info"
            v-if="clientCurrent"
          >
            {{ "group_chat" | setText("Групповой чат") }}
          </button>
        </div>
        <ul class="list">
          <li
            @click="clientCurrent = client"
            :class="`${
              clientCurrent && client.id == clientCurrent.id ? 'active' : ''
            }`"
            v-for="client in clients"
            :key="client.id"
          >
            <div><img :src="client.avatar" /></div>
            <span>{{ client.full_name }} </span>
            <div v-if="client.badge" class="badge">
              <span>{{ client.badge }}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="area">
        <chat-area v-if="clientCurrent" :client="clientCurrent" />
        <group-chat-area v-else :group_id="group_id" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import ChatArea from "@/components/Pupils/Chat/ChatArea";
import GroupChatArea from "@/components/Pupils/Chat/GroupChatArea";
import { getClients } from "@/_api/apiPupil";
export default {
  props: {
    group_id: {
      default: null,
    },
  },
  computed: {
    ...mapState(["message", "badge"]),
  },
  components: {
    ChatArea,
    GroupChatArea,
  },
  mounted() {},
  created() {
    this.getClients(this.group_id);
  },
  watch: {
    group_id(val) {
      this.clientCurrent = null;
      this.getClients(val);
    },
  },
  methods: {
    getClients: getClients,
  },
  data() {
    return {
      clients: [],
      clientCurrent: null,
    };
  },
  watch: {
    clientCurrent(val) {
      if (val.chat) {
        for (let i = 0; i < this.clients.length; i++) {
          if (this.clients[i].chat.id == val.chat.id) {
            // this.$store.dispatch("setBadge", this.badge - val.badge);
            this.clients[i].badge = 0;
            //send on read socket.
          }
        }
      }
    },
    message: {
      handler: function (val) {},
      deep: true,
    },
  },
};
</script>
